module.exports = __webpack_public_path__ + "media/taikong.3bd256dd.mp3";